import { Tooltip } from '@festina-life/ui/feedback'
import { Card, CardBody, Icon } from '@festina-life/ui/structure'

import type { SubTemplateValueSetupField } from '../../../types/templateModel'
import { TemplateFieldsTable } from '../../templateFieldsTable/TemplateFieldsTable'

type Props = {
  field: SubTemplateValueSetupField
}

export const CcCalcStepFieldValuePosts = ({ field }: Props) => {
  const postsVariant = field.value?.variants.at(0)

  return (
    <Tooltip
      tip={
        <Card>
          <CardBody outerClassName="min-w-250">
            <TemplateFieldsTable
              level={0}
              parent={field}
              fields={postsVariant?.fields}
              isCollapsible={false}
            />
          </CardBody>
        </Card>
      }
      className="h-full grow"
    >
      <div className="flex size-full items-center justify-center">
        <Icon name="Envelope" className="text-primary" color="unset" />
      </div>
    </Tooltip>
  )
}
